import { createAction, handleActions } from 'redux-actions';
import { Api } from '../../api/api';
import { logout, onForbidden } from '../account/login';

//- Actions
export const fetchGetLevelsFailed = createAction('FETCH_GET_LEVELS_FAILED');
export const fetchGetLevelsSuccess = createAction('FETCH_GET_LEVELS_SUCCESS');
export const fetchGetLevels = createAction(
    'FETCH_GET_LEVELS',
    () => Api.getLevels(),
    () => ({
        apiCall: true,
        onSuccess: fetchGetLevelsSuccess,
        onFail: fetchGetLevelsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const clearLevels = createAction('CLEAR_LEVELS');

//- State
const initialState = {
    data: null,
    error: null,
    fetching: false
};

//- Reducers
export default handleActions({

    FETCH_GET_LEVELS: (state) => {
        return { ...state, data: null, error: null, fetching: true };
    },
    FETCH_GET_LEVELS_FAILED: (state, action) => {
        return { ...state, data: null, error: action.payload, fetching: false };
    },
    FETCH_GET_LEVELS_SUCCESS: (state, action) => {
        return { ...state, data: action.payload, error: null, fetching: false };
    },
    CLEAR_LEVELS: (state) => {
        return { ...state, data: null };
    }

}, initialState);

//- Selectors
export const getLevels = state => state.levels;

export const getLevelsData = state => getLevels(state).data;

export const loadingLevels = state => getLevels(state).fetching;



// WEBPACK FOOTER //
// ./src/reducers/common/levels.js